import { render, staticRenderFns } from "./TheTransactionsHistoryTableItem.vue?vue&type=template&id=220ff75a&scoped=true"
import script from "./TheTransactionsHistoryTableItem.vue?vue&type=script&lang=js"
export * from "./TheTransactionsHistoryTableItem.vue?vue&type=script&lang=js"
import style0 from "./TheTransactionsHistoryTableItem.vue?vue&type=style&index=0&id=220ff75a&prod&lang=scss&scoped=true"
import style1 from "./TheTransactionsHistoryTableItem.vue?vue&type=style&index=1&id=220ff75a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ff75a",
  null
  
)

export default component.exports